import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import EnvCropsFailedOrdersContext from './EnvCropsFailedOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const EnvCropsFailedOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <EnvCropsFailedOrdersContext.Provider value={{ actions, selectors, state }}>
      {children}
    </EnvCropsFailedOrdersContext.Provider>
  );
};

export default EnvCropsFailedOrdersProvider;
